import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { PatientsListSer } from './Services/PatientsListSer';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
const PatientsLists= () => {
    useEffect(() => {
             const scriptUrls = [
               'assets/js/jquery.min.js',
               'assets/js/bootstrap.bundle.min.js',
               'assets/js/moment.min.js',
               'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
               'assets/vendor/overlay-scroll/custom-scrollbar.js',
               'assets/vendor/daterange/daterange.js',
               'assets/vendor/daterange/custom-daterange.js',
               'assets/vendor/rating/raty.js',
               'assets/vendor/rating/raty-custom.js',
               'assets/js/custom.js'
             ];
         
             let isCancelled = false;
         
             // Load scripts sequentially
             const loadScriptsSequentially = async () => {
               for (const url of scriptUrls) {
                 if (isCancelled) break;
         
                 await new Promise((resolve, reject) => {
                   const script = document.createElement('script');
                   script.src = url;
                   script.onload = resolve;
                   script.onerror = reject;
                   document.body.appendChild(script);
                 });
               }
             };
         
             loadScriptsSequentially();
         
             return () => {
               isCancelled = true;
               // Optionally remove scripts if needed
             };
           }, []);
    const navigator = useNavigate();
           const handleViewClick = (e,id) => {
        e.preventDefault();
         // Navigate to /page2 and pass the value
         navigator('/patients-profile', { state: { uata: id } });
         window.location.reload();
       };
       
    
    /* const dummyData =[
        {
            "id":1,
            "users":"Gautam Kumar",
            "title":"Dam it",
            "author":"Rest Api",
            "isbn":"isbn34546",
            "description":"This is really good",
            "backCover":"file1.jpg"
        }
    ] */
        const [department, setDepartment] = useState([]);
        const srcImg="http://localhost:8080/Images/";
        useEffect(() =>{
            const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
            const listDoctorUser =() => axios.get(REST_API_BASE_URL);
            listDoctorUser().then((response) => {
                setDepartment(response.data);
            }).catch(error =>{
                console.error(error);
            })
        } , [])
        
        return(
            <div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Patients List
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="card-title m-0">Patients List</h5>
              <div className="ms-auto d-flex gap-2">
                {/* Search Patient Starts */}
                <div className="search-container d-xl-block d-none">
                  <input type="text" className="form-control border" id="searchPatient" placeholder="Search" />
                  <i className="ri-search-line" />
                </div>
                {/* Search Patient Ends */}
                {/* Button Group Starts */}
                <a href="/add-patients" className="btn btn-primary">Add Patient</a>
                {/* Button Group Ends */}
              </div>
            </div>
          </div>
          <div className="card-body">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient1.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0001
                          </div>
                          <div className="fw-semibold mb-1">Janine Gomez</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 32</li>
                            <li className="px-2 border-end">Female</li>
                            <li className="px-2">O+</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 06/06/2024 at
                          2:30PM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient2.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0002
                          </div>
                          <div className="fw-semibold mb-1">Graciela Chase</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 39</li>
                            <li className="px-2 border-end">Female</li>
                            <li className="px-2">B+</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 18/02/2024 at
                          6:30PM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient3.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0003
                          </div>
                          <div className="fw-semibold mb-1">Rose Lindsey</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 32</li>
                            <li className="px-2 border-end">Female</li>
                            <li className="px-2">AB+</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 16/01/2024 at
                          4:45PM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient4.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0004
                          </div>
                          <div className="fw-semibold mb-1">Alba Mathews</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 65</li>
                            <li className="px-2 border-end">Female</li>
                            <li className="px-2">A-</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 20/03/2024 at
                          3:45PM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0005
                          </div>
                          <div className="fw-semibold mb-1">Jacob Calderon</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 23</li>
                            <li className="px-2 border-end">Male</li>
                            <li className="px-2">O-</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 09/02/2024 at
                          10:30AM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="card mb-4 border">
                  <div className="card-body">
                    <a href="/patients-profile">
                      <div className="d-flex flex-wrap gap-3 border-bottom mb-2">
                        <img src="assets/images/patient5.png" className="img-4x rounded-3" alt="Dental Admin Dashboard" />
                        <div className="d-flex flex-column">
                          <div className="text-primary mb-1">
                            #PT0006
                          </div>
                          <div className="fw-semibold mb-1">Cyrus Henson</div>
                          <ul className="list-unstyled d-flex">
                            <li className="pe-2 border-end">Age: 48</li>
                            <li className="px-2 border-end">Male</li>
                            <li className="px-2">B+</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <h6 className="text-primary">Diagnosis</h6>
                        <p className="text-truncate mb-2">The process of identifying a disease, condition, or injury
                          from its signs and symptoms.
                        </p>
                        <p className="text-truncate m-0"><span className="text-primary">Last Visit:</span> 24/02/2024 at
                          6:15PM</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
             
            </div>
            {/* Row ends */}
          </div>
          <div className="card-footer">
            {/* Pagination starts */}
            <nav>
              <ul className="pagination justify-content-center">
                <li className="page-item">
                  <a className="page-link">
                    <i className="ri-arrow-left-s-line" />
                  </a>
                </li>
                <li className="page-item"><a className="page-link" href="#">1</a></li>
                <li className="page-item"><a className="page-link" href="#">2</a></li>
                <li className="page-item"><a className="page-link" href="#">3</a></li>
                <li className="page-item"><a className="page-link" href="#">4</a></li>
                <li className="page-item"><a className="page-link" href="#">5</a></li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    <i className="ri-arrow-right-s-line" />
                  </a>
                </li>
              </ul>
            </nav>
            {/* Pagination ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>

        );
        
}

export default PatientsLists;